const e=`html-email-item-grid-column`,t=`html-email-item-grid-spacer`;export{e as itemGridColumn,t as itemGridSpacer};
//# sourceMappingURL=css-classes.js.map